import { ApiService } from '@/services/api.services';
import { useQuery } from '@tanstack/react-query';

export const useHomeQuery = () => {
  return useQuery({
    queryKey: ['home'],
    queryFn: ApiService.getHomePage,
    staleTime: 1000 * 60 * 5, // override jika perlu
    refetchOnWindowFocus: true,
  });
};
